import React, { Fragment } from "react";
import { SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";
import { useDispatch, useSelector } from "react-redux";
import VersionControlIosForm from "./VersionControlIosForm";
import VersionControlAndroidForm from "./VersionControlAndroidForm";

const ConfigVersionControlUi = () => {
  const data = useSelector((state) => state.systemconfig);
  const dispatch = useDispatch();
  let initialValues = {
    version_control: {
      android: {
        minimum_version: 0,
        threshold_version: 0,
        message: ""
      },
      ios: {
        minimum_version: 0,
        threshold_version: 0,
        message: ""
      }
    }
  };
  // console.log('svnisoevnsev', data)
  if (data) {
    initialValues = {
      ...data
    }
  }
  const handleFormSubmit = async (values, { setSubmitting }, ...rest) => {
    try {
      setSubmitting(true);
      let method = "post";
      let endpoint = `configs`;
      // console.log("snvuisbevsevsdvs");
      if (values?._id) {
        method = "put";
        endpoint = `configs/${values?._id}`;
      }
      if (rest[0] == 'android') {
        values.version_control.ios = data?.version_control?.ios;
      } else if (rest[0] == 'ios') {
        values.version_control.android = data?.version_control?.android;
      }
      const response = await apiCaller({ method, data: values, url: endpoint })
        .then((response) => {
          //   dispatch(confirmedUpdatePostAction(post));
          // history.push(backUrl);
          // console.log('snvioesev', response);
          return response;
        })
        .catch((error) => {
          console.log("anvuoinsevsev", error);
          throw error;
        });
      localStorage.setItem('systemconfigs', JSON.stringify(response?.data?.data));
      dispatch({ type: SET_SYSTEM_CONFIG, payload: response?.data?.data });
      setSubmitting(false);
    } catch (error) { }
  };
  return (
    <Fragment>
      <div className="row container-mxw">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">
                ios App Version Control
              </h4>
              <p>Manage iOS versions with force or optional updates.</p>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <VersionControlIosForm initialValues={initialValues} handleFormSubmit={handleFormSubmit} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">
                Android App Version Control
              </h4>
              <p>Manage Android versions with force or optional updates.</p>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <VersionControlAndroidForm initialValues={initialValues} handleFormSubmit={handleFormSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ConfigVersionControlUi;
